import request from '@/utils/request'

import { View, ViewShort, IDefaultView, IPanel } from '../types/view'

/** Get default view for current user */
export function Default(): Promise<IDefaultView> {
  return request.get('/v')
}

export function getViewBySlugAndUid(slug: string, uid: string): Promise<View> {
  return request.get(`/v/${uid}/${slug}`)
}

export function patchViewData(uid: string, slug: string, data: View) {
  return request.patch(`/view/${uid}/${slug}`, data)
}

interface NewView {
  title: string
  isGroup: boolean
  panels?: Array<IPanel>
  // eslint-disable-next-line
  attributes?: any
}

/** Create view. */
export function Create(data: View | NewView): Promise<View> {
  return request.post('/view', data)
}

/** Delete view. */
export function Delete(id: number) {
  return request.delete(`/view/${id}`)
}

/** Get list of view without panels & attributes. */
export function Find(): Promise<ViewShort[]> {
  return request.get('/view')
}

/** Ambil data view dari server berdasarkan id yang diberikan. */
export function Get(id: number): Promise<View> {
  return request.get(`/view/${id}`)
}

/**
 * Patch view
 * @param id ID of view
 * @param view View data
 */
export function Patch(id: number, view: View): Promise<ViewShort> {
  return request.patch(`/view/${id}`, view)
}
